import React, { useState, useEffect, useRef } from 'react';
import Modal from '../../../../components/modal';
import styles from './style.module.scss';
import TextInput from '../../../../components/form/text-input';
import { Formik, Form } from 'formik';
import Button from '../../../../components/new-button/index.jsx';
import * as Yup from 'yup';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import { updateVarSheet, getVarSheet } from '../../../../../api';
import toast from 'react-hot-toast';

function EditVarSheet({ isOpen, onClose, powerapp_id }) {

  const defaultValues = {
    // ems_mid: '',
    model: '',
    build_notes: '',
    office: '',
    rep_code: '',
    branch: '',
    merchant: '',
    v_number: '',
    tpn: '',
    discover: '',
    platform_host: '',
    bin: '',
    agent: '',
    chain: '',
    store: '',
    country_code: '',
    terminal: '',
    currency_code: '',
    sic_code: '',
    time_zone: '',
    location: '',
    zip_code: '',
    authorization_settlement_url: '',
    authorization_settlement_port: '',
    authorization_phone: '',
    settlement_phone: '',
    merchant_name: '',
    address: '',
    city: '',
    state: '',
    phone: '',
    software: '',
    amex: '',
  };

  const [initialValues, setInitialValues] = useState(defaultValues);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    const sanitize = (data) => {
      // Merge known keys and coerce null/undefined to empty strings
      const merged = { ...defaultValues };
      if (data && typeof data === 'object') {
        Object.keys(defaultValues).forEach((key) => {
          const value = data[key];
          merged[key] = value ?? '';
        });
      }
      return merged;
    };

    const fetchData = async () => {
      const res = await getVarSheet(powerapp_id);
      if (res.status && isMountedRef.current) {
        setInitialValues(sanitize(res.data));
      }
    };

    fetchData();
    return () => {
      isMountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (values, { setSubmitting, errors }) => {
    setShowConfirmationModal(true);
    setIsSubmitting(true);
    setInitialValues(values);
  }

  const onConfirmClick = async () => {
    if (isMountedRef.current) setIsSubmitting(true);
    try {
      const res = await updateVarSheet(initialValues, powerapp_id);
      if (res.status) {
        if (isMountedRef.current) {
          setShowConfirmationModal(false);
        }
        onClose();
        toast.success('VAR Sheet updated successfully');
        // Do not set state after onClose; component may unmount
      } else {
        toast.error(res.message || 'Failed to update VAR Sheet');
        if (isMountedRef.current) setIsSubmitting(false);
      }
    } catch (e) {
      toast.error('Failed to update VAR Sheet');
      if (isMountedRef.current) setIsSubmitting(false);
    }
  }

  const onCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
  }

  const validationSchema = Yup.object().shape({
    // ems_mid: Yup.string().required('EMS MID is required'),
    model: Yup.string().nullable().optional('Model is required'),
    build_notes: Yup.string().nullable().optional('Build Notes is required'),
    office: Yup.string().nullable().optional('Office is required'),
    rep_code: Yup.string().nullable().optional('Rep Code is required'),
    branch: Yup.string().nullable().optional('Branch is required'),
    merchant: Yup.string().nullable().optional('Merchant is required'),
    v_number: Yup.string().nullable().optional('V# is required'),
    tpn: Yup.string().nullable().optional('TPN is required'),
    discover: Yup.string().nullable().optional('Discover is required'),
    platform_host: Yup.string().nullable().optional('Platform (HOST) is required'),
    bin: Yup.string().nullable().optional('BIN# is required'),
    agent: Yup.string().nullable().optional('Agent is required'),
    chain: Yup.string().nullable().optional('Chain is required'),
    store: Yup.string().nullable().optional('Store is required'),
    country_code: Yup.string().nullable().optional('Country Code is required'),
    terminal: Yup.string().nullable().optional('Terminal is required'),
    currency_code: Yup.string().nullable().optional('Currency Code is required'),
    sic_code: Yup.string().nullable().optional('SIC Code is required'),
    time_zone: Yup.string().nullable().optional('Time Zone is required'),
    location: Yup.string().nullable().optional('Location# is required'),
    zip_code: Yup.string().nullable().optional('Zip Code is required'),
    authorization_settlement_url: Yup.string().nullable().optional('Authorization/Settlement URL is required'),
    authorization_settlement_port: Yup.string().nullable().optional('Authorization/Settlement Port# is required'),
    authorization_phone: Yup.string().nullable().optional('Authorization Phone# is required'),
    settlement_phone: Yup.string().nullable().optional('Settlement Phone# is required'),
    merchant_name: Yup.string().nullable().optional('Merchant Name is required'),
    address: Yup.string().nullable().optional('Address is required'),
    city: Yup.string().nullable().optional('City is required'),
    state: Yup.string().nullable().optional('State is required'),
    phone: Yup.string().nullable().optional('Phone is required'),
    software: Yup.string().nullable().optional('Software is required'),
    amex: Yup.string().nullable().optional('Amex# is required'),
  });

  const showErrors = (errors) => {
    console.log('errors', errors);
    if (Object.keys(errors).length > 0) {
      toast.error('Please fill all the required fields');
    }
  }


  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setShowConfirmationModal(false);
      }}
      header="Edit VAR Sheet"
      size="xl"
    >
      <Formik
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
        initialValues={initialValues}
      >
        {({ handleSubmit, values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
          <Form
            onSubmit={handleSubmit}
          >
            <div className={styles.editVarSheetModalContent}>
              <div className={`${styles.grid} ${styles.gridCols4} ${styles.gap1}`} >

                {/* <TextInput
                  label="EMS MID"
                  name="ems_mid"
                  value={values.ems_mid}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.ems_mid}
                  errored={errors.ems_mid}
                  error={errors.ems_mid}
                /> */}

                <TextInput label="Model" name="model"
                  value={values.model}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.model}
                  errored={errors.model}
                  error={errors.model}
                />

                <TextInput label="Build Notes" name="build_notes"
                  value={values.build_notes}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.build_notes}
                  errored={errors.build_notes}
                  error={errors.build_notes}
                />

                <TextInput label="Office" name="office"
                  value={values.office}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.office}
                  errored={errors.office}
                  error={errors.office}
                />

                <TextInput label="Rep Code" name="rep_code"
                  value={values.rep_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.rep_code}
                  errored={errors.rep_code}
                  error={errors.rep_code}
                />

                <TextInput label="Branch" name="branch"
                  value={values.branch}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.branch}
                  errored={errors.branch}
                  error={errors.branch}
                />

                <TextInput label="Merchant" name="merchant"
                  value={values.merchant}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.merchant}
                  errored={errors.merchant}
                  error={errors.merchant}
                />

                <TextInput label="V#" name="v_number"
                  value={values.v_number}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.v_number}
                  errored={errors.v_number}
                  error={errors.v_number}
                />

                <TextInput label="TPN" name="tpn"
                  value={values.tpn}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.tpn}
                  errored={errors.tpn}
                  error={errors.tpn}
                />

                <TextInput label="Discover" name="discover"
                  value={values.discover}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.discover}
                  errored={errors.discover}
                  error={errors.discover}
                />

                <TextInput label="Platform (HOST)" name="platform_host"
                  value={values.platform_host}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.platform_host}
                  errored={errors.platform_host}
                  error={errors.platform_host}
                />

                <TextInput label="BIN#" name="bin"
                  value={values.bin}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.bin}
                  errored={errors.bin}
                  error={errors.bin}
                />

                <TextInput label="Agent" name="agent"
                  value={values.agent}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.agent}
                  errored={errors.agent}
                  error={errors.agent}
                />

                <TextInput label="Chain" name="chain"
                  value={values.chain}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.chain}
                  errored={errors.chain}
                  error={errors.chain}
                />

                <TextInput label="Store" name="store"
                  value={values.store}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.store}
                  errored={errors.store}
                  error={errors.store}
                />

                <TextInput label="Country Code" name="country_code"
                  value={values.country_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.country_code}
                  errored={errors.country_code}
                  error={errors.country_code}
                />
                <TextInput label="Terminal" name="terminal"
                  value={values.terminal}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.terminal}
                  errored={errors.terminal}
                  error={errors.terminal}
                />

                <TextInput label="Currency Code" name="currency_code"
                  value={values.currency_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.currency_code}
                  errored={errors.currency_code}
                  error={errors.currency_code}
                />

                <TextInput label="SIC Code" name="sic_code"
                  value={values.sic_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.sic_code}
                  errored={errors.sic_code}
                  error={errors.sic_code}
                />

                <TextInput label="Time Zone" name="time_zone"
                  value={values.time_zone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.time_zone}
                  errored={errors.time_zone}
                  error={errors.time_zone}
                />

                <TextInput label="Location#" name="location"
                  value={values.location}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.location}
                  errored={errors.location}
                  error={errors.location}
                />

                <TextInput label="Zip Code" name="zip_code"
                  value={values.zip_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.zip_code}
                  errored={errors.zip_code}
                  error={errors.zip_code}
                />

                <TextInput label="Authorization/Settlement URL" name="authorization_settlement_url"
                  value={values.authorization_settlement_url}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.authorization_settlement_url}
                  errored={errors.authorization_settlement_url}
                  error={errors.authorization_settlement_url}
                />

                <TextInput label="Authorization/Settlement Port#" name="authorization_settlement_port"
                  value={values.authorization_settlement_port}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.authorization_settlement_port}
                  errored={errors.authorization_settlement_port}
                  error={errors.authorization_settlement_port}
                />

                <TextInput label="Authorization Phone#" name="authorization_phone"
                  value={values.authorization_phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.authorization_phone}
                  errored={errors.authorization_phone}
                  error={errors.authorization_phone}
                />

                <TextInput label="Settlement Phone#" name="settlement_phone"
                  value={values.settlement_phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.settlement_phone}
                  errored={errors.settlement_phone}
                  error={errors.settlement_phone}
                />

                <TextInput label="Merchant Name" name="merchant_name"
                  value={values.merchant_name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.merchant_name}
                  errored={errors.merchant_name}
                  error={errors.merchant_name}
                />

                <TextInput label="Address" name="address"
                  value={values.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.address}
                  errored={errors.address}
                  error={errors.address}
                />

                <TextInput label="City" name="city"
                  value={values.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.city}
                  errored={errors.city}
                  error={errors.city}
                />

                <TextInput label="State" name="state"
                  value={values.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.state}
                  errored={errors.state}
                  error={errors.state}
                />

                <TextInput label="Phone" name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.phone}
                  errored={errors.phone}
                  error={errors.phone}
                />

                <TextInput label="Software" name="software"
                  value={values.software}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.software}
                  errored={errors.software}
                  error={errors.software}
                />

                <TextInput label="Amex#" name="amex"
                  value={values.amex}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched.amex}
                  errored={errors.amex}
                  error={errors.amex}
                />
              </div>
            </div>

            <div className={styles.editVarSheetModalFooter}>
              <Button
                variant="secondary"
                type="button"
                onClick={onClose}>Cancel
              </Button>
              <Button
                type="submit"
                isLoading={isSubmitting}
                disabled={isSubmitting}
                onClick={() => {
                  showErrors(errors);
                }}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <ConfirmationModal
          open={showConfirmationModal}
          onClose={onCloseConfirmationModal}
          onConfirmClick={onConfirmClick}
          message="Are you sure? Want to edit VAR Sheet?"
          submitButtonText="Yes, Update it!"
        />
      )}
    </Modal>
  )
}

export default EditVarSheet